'use strict';

function getECToken(url) {
    var parts = url.split('EC-');
    return parts.length > 1 ? 'EC-' + parts[1].split('&')[0] : null;
}

module.exports = getECToken;


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/util/token-from-url.js
 ** module id = 31
 ** module chunks = 0
 **/